import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition-grid',
  templateUrl: './petition-grid.component.html',
  styleUrls: ['./petition-grid.component.css']
})
export class PetitionGridComponent implements OnInit {

  title = "Petitions List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition-grid/petition-grid.component.ts